import React, { useState } from "react";
import "./DrowerModalCss.css";

const ModalCenter = ({ children, name }) => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <button className="drower__modal-btn" onClick={() => setVisible(true)}>
        {name}
      </button>
      <div
        className={visible ? "drower-open-modal actives" : "drower-open-modal"}
        onClick={() => setVisible(false)}
      >
        <div></div>
        <section
          className={
            visible ? "drower-modal-content activ" : "drower-modal-content"
          }
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </section>
      </div>
    </>
  );
};

export default ModalCenter;
